import { render, staticRenderFns } from "./NewProposalForm.vue?vue&type=template&id=e5f6354e&scoped=true&"
import script from "./NewProposalForm.vue?vue&type=script&lang=js&"
export * from "./NewProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./NewProposalForm.vue?vue&type=style&index=0&id=e5f6354e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f6354e",
  null
  
)

export default component.exports